import { ReportSummary } from "src/app/models/models";
import { ReportSummaryLayoutResolver } from "../report-summary-layout.resolver";
import {
	ReportSummaryLayoutContext,
	ReportSummaryLayoutKey,
} from "../report-summary-layout.types";
import { resolveTs1ReportSummaryLayout } from "./ts1-report-summary.resolver";

export type { ReportSummaryLayoutContext, ReportSummaryLayoutKey } from "../report-summary-layout.types";
export type { ReportSummaryLayoutResolver } from "../report-summary-layout.resolver";

export const DEFAULT_REPORT_SUMMARY_RESOLVERS: ReportSummaryLayoutResolver[] = [
	resolveTs1ReportSummaryLayout,
];

export function isPfPmReportLayout(layoutKey: ReportSummaryLayoutKey): boolean {
	return layoutKey === "ts1-pfpm-v3" || layoutKey === "ts1-pfpm-v4";
}

export function resolveReportSummaryLayout(
	report: ReportSummary | undefined,
	resolvers: ReportSummaryLayoutResolver[] = DEFAULT_REPORT_SUMMARY_RESOLVERS,
): ReportSummaryLayoutContext {
	if (!report) {
		return { layoutKey: "legacy", formType: "" };
	}

	for (const resolver of resolvers) {
		const match = resolver(report);
		if (match) {
			return match;
		}
	}

	return {
		layoutKey: "legacy",
		formType: report.formType ?? "",
		formVersion: report.formVersion,
	};
}
